angular.module('app').factory('stylesService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        var configs = restAngular.all("/css/");

        return {
            getStylesMenu: function (requestOptions) {
                return configs.
                    one("get").
                    get(requestOptions);
            },
            getConfigByConfigSkinId: function (requestOptions) {
                return configs.
                    one("get").
                    get(requestOptions)
            },
            createStyleByConfigSkinId: function (requestData) {
                return configs.
                    one("create").
                    post("", requestData)
            },
            updateStyleByConfigSkinId: function (requestData) {
                return configs.
                    one("change").
                    post("", requestData)
            },
            generateCss: function () {
                return configs.
                    one("/convert").
                    get()
            },
            resetCss: function () {
                return configs.
                    one("/reset").
                    post()
            },
            applyCss: function () {
                return configs.
                    one("/apply").
                    post()
            },
            useTemplate: function (requsetData) {
                return configs.
                    one("usetemplate").
                    get(requsetData)
            }
        }
    }
]);